import { render, staticRenderFns } from "./Airtime.vue?vue&type=template&id=be4f9486&scoped=true&"
import script from "./Airtime.vue?vue&type=script&lang=js&"
export * from "./Airtime.vue?vue&type=script&lang=js&"
import style0 from "./Airtime.vue?vue&type=style&index=0&id=be4f9486&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4f9486",
  null
  
)

export default component.exports